import { IntlShape } from 'react-intl';

import { IdEnums, SelectTypes } from '@nhl/nhl-breakaway-ui';

import CommonMessages from '~/core/commonMessages';

export const createGameTypeOption = (intl: IntlShape, gameType: IdEnums.GameType): SelectTypes.BasicOption => ({
    key: gameType,
    value: gameType,
    label: intl.formatMessage(CommonMessages.gameTypeDescriptions.long[gameType]),
});

// for when we want "Playoffs" and not "Stanley Cup Playoffs"
export const createShortGameTypeOption = (intl: IntlShape, gameType: IdEnums.GameType): SelectTypes.BasicOption => ({
    key: gameType,
    value: gameType,
    label: intl.formatMessage(CommonMessages.gameTypeDescriptions.short[gameType]),
});
